/**
 * Story 3.16.1 — Timezone curated list for `BusinessHoursEditor`.
 *
 * BR-first list (8 IANA names commonly used in Brazil) + 3 globais para
 * cases raros. Offsets são informativos (labels human-readable); backend
 * usa apenas o `value` (IANA name). Sem cálculo dinâmico de DST — Brasil
 * aboliu DST em 2019; outros TZs com DST mostram offset padrão.
 *
 * Storage no `system_settings.business_hours.timezone` permanece string
 * IANA — esta lista NÃO restringe o que o backend aceita (validator
 * usa apenas `typeof === 'string'`). Para timezones fora da lista, o
 * admin usa o JSON escape hatch do BusinessHoursEditor.
 */

export interface TimezoneOption {
  value: string
  label: string
  group: 'br' | 'other'
}

export const TIMEZONES_BR: ReadonlyArray<TimezoneOption> = [
  // Brasil — 8 timezones IANA usados em rota
  { value: 'America/Sao_Paulo', label: '🇧🇷 América/São Paulo (BRT, UTC-3)', group: 'br' },
  { value: 'America/Manaus', label: '🇧🇷 América/Manaus (AMT, UTC-4)', group: 'br' },
  { value: 'America/Cuiaba', label: '🇧🇷 América/Cuiabá (AMT, UTC-4)', group: 'br' },
  { value: 'America/Belem', label: '🇧🇷 América/Belém (BRT, UTC-3)', group: 'br' },
  { value: 'America/Fortaleza', label: '🇧🇷 América/Fortaleza (BRT, UTC-3)', group: 'br' },
  { value: 'America/Recife', label: '🇧🇷 América/Recife (BRT, UTC-3)', group: 'br' },
  { value: 'America/Rio_Branco', label: '🇧🇷 América/Rio Branco (ACT, UTC-5)', group: 'br' },
  { value: 'America/Noronha', label: '🇧🇷 América/Noronha (FNT, UTC-2)', group: 'br' },
  // Outros — globais comuns
  { value: 'UTC', label: 'UTC', group: 'other' },
  { value: 'America/New_York', label: 'América/New York (ET)', group: 'other' },
  { value: 'Europe/Lisbon', label: 'Europa/Lisboa (WET)', group: 'other' },
]

/**
 * Returns `true` when the IANA name is in the curated list. Used to decide
 * if the dropdown should show the value as a selected option OR fallback
 * for "fora da lista" (e.g. valor antigo carregado do backend que não está
 * mais na curated list — UI exibe valor crú mas sem label decorado).
 */
export function isCuratedTimezone(value: string): boolean {
  return TIMEZONES_BR.some((tz) => tz.value === value)
}
